import React, { useRef, useState } from "react";
import { SearchNormal1 } from 'iconsax-react';
import { RiCloseLine, RiMenuFill } from "react-icons/ri";
import { Layout, Row, Col, Button } from "antd";
import MenuLogo from "../menu/logo";
import MenuHorizontal from "../menu/item/MenuHorizontal";
import HeaderSearch from "./HeaderSearch";
import HeaderNotifications from "./HeaderNotifications";
import HeaderUser from "./HeaderUser";
import HeaderLanguages from "./HeaderLanguages";
import { withTranslation } from "react-i18next";
import { compose } from "redux";
import { withRouter } from "react-router-dom";
import MenuMobile from "../menu/mobile";
import i18next from "i18next";
import HeaderSwitch from "./HeaderSwitch";

const { Header } = Layout;

function HeaderHorizontal(props) {
  const { userInfo, setVisible, menuItems, language, languageData, loginOut, visible, isHiddle, history, selectedModel } = props;

  const [searchHeader, setSearchHeader] = useState(false);
  const [searchActive, setSearchActive] = useState(false);

  // Header Class
  const [headerClass, setHeaderClass] = useState()

  // Mobile Sidebar
  const onClose = () => {
    setVisible(false);
  };

  // Focus
  const inputFocusRef = useRef(null);
  const inputFocusProp = {
    ref: inputFocusRef,
  };

  // Search Active
  setTimeout(() => setSearchActive(searchHeader), 100);

  const searchClick = () => {
    setSearchHeader(true)

    setTimeout(() => {
      inputFocusRef.current.focus({
        cursor: 'start',
      });
    }, 200);
  }

  // Mobile Sidebar
  const showDrawer = () => {
    setVisible(true);
    setSearchHeader(false);
  };

  // Children
  const headerChildren = () => {
    return (
      <Row
        className="hp-w-100 hp-position-relative"
        align="middle"
        justify="space-between"
      >
        <Row justify="center">
          {!isHiddle && <Col className="hp-mobile-sidebar-button hp-ml-16 flex-center">
            <Button
              className="hp-mobile-sidebar-button"
              type="text"
              onClick={showDrawer}
              icon={
                <RiMenuFill
                  size={24}
                  className="remix-icon hp-text-color-black-80"
                />
              }
            />
          </Col>}
          
          <MenuLogo selectedModel={selectedModel} />
        </Row>

        {
          !isHiddle && !searchHeader && (
            <Col flex="1 0 0" className="hp-mx-24">
              <MenuHorizontal navigation={menuItems} language={language} {...props} />
            </Col>
          )
        }

        {!isHiddle && <Col
          flex="1"
          style={{ display: !searchHeader ? 'none' : 'block' }}
          className={`hp-ml-md-0 hp-pr-md-0 hp-ml-32 hp-pl-0 hp-header-search ${searchActive && "hp-header-search-active"}`}
        >
          <div style={{ paddingLeft: 16, paddingRight: 16 }}>
            <HeaderSearch inputFocusProp={inputFocusProp} setSearchHeader={setSearchHeader} {...props} />
          </div>
        </Col>}
        
        {!isHiddle && <Col>
          <Row align="middle">
            <HeaderSwitch />
            {/* <HeaderLanguages languages={languageData} /> */}

            <Col className="hp-mr-sm-0 hp-mr-4 hp-d-flex-center">
              {!searchHeader ? (
                <Button
                  ghost
                  className="hp-border-none hp-hover-bg-black-10 hp-hover-bg-dark-100"
                  icon={
                    <SearchNormal1
                      set="curved"
                      className="hp-text-color-black-80 hp-text-color-dark-30"
                    />
                  }
                  onClick={() => searchClick()}
                />
              ) : (
                <Button
                  ghost
                  className="hp-border-none hp-hover-bg-black-10 hp-hover-bg-dark-100"
                  icon={
                    <RiCloseLine
                      size={24}
                      className="hp-text-color-black-80 hp-text-color-dark-30"
                    />
                  }
                  onClick={() => setSearchHeader(false)}
                />
              )}
            </Col>

            {/* <HeaderNotifications {...props} /> */}

            <HeaderUser userInfo={userInfo} loginOut={() => loginOut()} />
          </Row>
        </Col>}

        {isHiddle && <Button block type="primary" style={{ width: 80 }} onClick={() => history.push('/')}>
          {i18next.t('translations.login')}
        </Button>}

      </Row>
    )
  }

  return (
    <Header
      className={'hp-header-horizontal'}
    >
      <Row justify="center" className="hp-w-100">
        <Col span={24}>
          {headerChildren()}
        </Col>
      </Row>

      <MenuMobile language={language} navigation={menuItems} onClose={onClose} visible={visible} {...props} />
    
    </Header>
  );
};

const enhance = compose(
  withRouter,
  withTranslation('translations')
);

export default enhance(HeaderHorizontal);
